import { useEffect, useState } from 'react';
import { Network } from '@capacitor/network';

/**
 * Of er verbinding is.
 *
 * @capacitor/network gebruikt op iOS de systeemstatus en op het web navigator.onLine
 * met de online/offline events, dus één hook volstaat voor beide.
 *
 * Start op `true`: de eerste status komt asynchroon binnen en een banner die bij elke
 * paginalading kort "geen verbinding" flitst is erger dan een seconde te laat.
 */
export const useNetworkStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    let active = true;
    let removeListener: (() => void) | undefined;

    Network.getStatus()
      .then((status) => {
        if (active) setIsOnline(status.connected);
      })
      .catch(() => {
        // Geen plugin (bijvoorbeeld in tests): dan gaan we uit van verbinding.
      });

    Network.addListener('networkStatusChange', (status) => {
      if (active) setIsOnline(status.connected);
    })
      .then((handle) => {
        // De listener kan al opgeruimd zijn voordat de promise klaar is.
        if (active) {
          removeListener = () => handle.remove();
        } else {
          handle.remove();
        }
      })
      .catch(() => {});

    return () => {
      active = false;
      removeListener?.();
    };
  }, []);

  return isOnline;
};
